var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"promo-3mff"},[_c('div',{staticClass:"promo-3mff__wrapper"},[_c('p',{staticClass:"promo-3mff__text"},[_vm._v(" "+_vm._s(_vm.$t('renew.upgrade.label.3mff_banner'))+" ")]),_c('img',{staticClass:"promo-3mff__image",attrs:{"src":require("@/assets/images/campaigns/3mff-promo-icon.png"),"alt":"promo"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }